<div class="logo-container">
    <span class="helper"></span>
    <img [src]="logoUrl" [title]="name" [alt]="name" *ngIf="logoUrl" />
    <div *ngIf="!logoUrl" class="logo-fallback">
        {{ name }}
    </div>
</div>
<div *ngIf="role" class="role text-center selenium-role">{{ role }}</div>
